import { Link } from "react-router-dom";

const courses = [
  {
    tag: "CERTIFICATION",
    name: "BLS Certification",
    description: "Basic Life Support for healthcare professionals. Covers CPR, AED, airway management, and team dynamics.",
    icon: "ri-heart-pulse-line",
    featured: true,
  },
  {
    tag: "RENEWAL",
    name: "BLS Renewal",
    description: "Renew your existing BLS certification with updated techniques and streamlined skills testing.",
    icon: "ri-refresh-line",
    featured: true,
  },
  {
    tag: "ADVANCED",
    name: "ACLS Certification",
    description: "Advanced Cardiovascular Life Support for healthcare providers managing cardiopulmonary emergencies.",
    icon: "ri-heart-3-line",
    featured: true,
  },
  {
    tag: "PEDIATRIC",
    name: "PALS Certification",
    description: "Pediatric Advanced Life Support equipping providers to handle emergencies in infants and children.",
    icon: "ri-baby-line",
    featured: false,
  },
  {
    tag: "INSTRUCTOR",
    name: "BLS Instructor Course",
    description: "Become an authorized BLS instructor. Teach and certify others with AHA-aligned credentials.",
    icon: "ri-user-star-line",
    featured: false,
  },
  {
    tag: "ESSENTIAL",
    name: "CPR / AED",
    description: "Learn CPR and AED operation for adults, children, and infants. Ideal for workplaces and general public.",
    icon: "ri-first-aid-kit-line",
    featured: false,
  },
  {
    tag: "ESSENTIAL",
    name: "First Aid",
    description: "Comprehensive First Aid training covering wound care, choking, shock, fractures, and emergency response.",
    icon: "ri-medicine-bottle-line",
    featured: false,
  },
  {
    tag: "CORPORATE",
    name: "Group Training",
    description: "On-site or in-house group training tailored for teams, hospitals, businesses, and organizations.",
    icon: "ri-group-line",
    featured: false,
  },
];

export default function CoursesPreview() {
  return (
    <section className="py-24 bg-brand-purple-pale">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-brand-purple text-white text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-full mb-4">
            Our Programs
          </span>
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-brand-black mb-4">
            Professional Certification Courses
          </h2>
          <div className="w-20 h-1 bg-brand-gold mx-auto mb-4" />
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            Every course is delivered by <strong>Registered Nurse instructors</strong> and aligned
            with American Heart Association standards — in Kissimmee, FL.
          </p>
        </div>

        {/* Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          {courses.map((course) => (
            <div
              key={course.name}
              className={`bg-white rounded-xl p-6 transition-all duration-300 hover:-translate-y-1 cursor-pointer ${
                course.featured ? "border-2 border-brand-gold" : "border border-gray-100"
              }`}
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-brand-purple-pale rounded-lg text-brand-purple">
                  <i className={`${course.icon} text-xl`} />
                </div>
                <span className={`text-xs font-bold uppercase tracking-wider px-2 py-1 rounded-full ${
                  course.featured ? "bg-brand-gold/20 text-brand-gold-dark" : "bg-gray-100 text-gray-500"
                }`}>
                  {course.tag}
                </span>
              </div>
              <h3 className="font-serif font-bold text-lg text-brand-black mb-2">{course.name}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-5">{course.description}</p>
              <Link
                to="/booking#reserve-spot"
                className="block text-center bg-brand-purple text-white text-sm font-semibold py-2.5 rounded-md hover:bg-brand-purple-dark transition-colors cursor-pointer whitespace-nowrap"
              >
                Book This Course
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/courses"
            className="inline-flex items-center gap-2 border-2 border-brand-purple text-brand-purple font-semibold px-8 py-3 rounded-md hover:bg-brand-purple hover:text-white transition-colors cursor-pointer whitespace-nowrap"
          >
            View All Courses
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
